<template>
  <footer class="site-footer">
    <div class="shell footer-top">
      <div class="footer-brand">
        <a href="#top" aria-label="Back to top"
          ><img
            src="/brand/logo-stacked-reverse.svg"
            width="220"
            height="152"
            alt="West Dev Solutions"
        /></a>
        <p>
          Backend systems, web and mobile apps, and automation for growing
          businesses.
        </p>
      </div>
      <ul class="footer-contact">
        <li>
          <a :href="contact.whatsappUrl" target="_blank" rel="noopener noreferrer"
            >WhatsApp {{ contact.phoneDisplay }}
            <span class="sr-only"> (opens WhatsApp)</span></a
          >
        </li>
        <li><a :href="`mailto:${contact.email}`">{{ contact.email }}</a></li>
        <li>
          <a :href="contact.instagramUrl" target="_blank" rel="noopener noreferrer"
            >Instagram <span aria-hidden="true">↗</span
            ><span class="sr-only"> (opens in a new tab)</span></a
          >
        </li>
      </ul>
    </div>
    <div class="shell footer-bottom">
      <nav class="footer-links" aria-label="Footer">
        <a href="#services">Services</a>
        <a href="#work">Work</a>
        <a href="#process">Process</a>
        <a href="#about">About</a>
        <a href="#faq">FAQ</a>
        <a href="/connect">Contact hub &amp; QR</a>
      </nav>
      <span>© {{ new Date().getFullYear() }} West Dev Solutions LLC</span>
    </div>
  </footer>
</template>
<script>
import contact from "@/config/contact";

export default {
  name: "FooterElement",
  data: () => ({ contact }),
};
</script>
